import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
    providedIn: 'root',
})
export class ThemeService {
    public primaryColor = '#7c1e60'; // Default primary color
    public secColor = '#7f2165';
    public tColor = '#f15e55';
    public extraColor1 = '#76155a';
    private bgImg:BehaviorSubject<string> = new BehaviorSubject<string>('');
    private logoImg: BehaviorSubject<string> = new BehaviorSubject<string>('');
    setPrimaryColor(color: string, color1: string, color2:string,color3:string): void {
        this.primaryColor = color;
        this.secColor = color1;
        this.tColor = color2;
        this.extraColor1 = color3;
    }

    setLogo(data:string){
        this.logoImg.next(data);
    }
    getLogo(){
        return this.logoImg.asObservable();
    }
    setBg(data:string){
        this.bgImg.next(data);
    }
    getBg(){
        return this.bgImg.asObservable();
    }

}
